<template>
  <section
    class="powerbi-analytics-widget"
    :class="{
      'powerbi-analytics-widget--single': shortcuts.length === 1,
      'powerbi-analytics-widget--empty-state': !hasOnlineSamples,
    }"
  >
    <div class="powerbi-analytics-card">
      <button
        v-for="shortcut in shortcuts"
        :key="shortcut.routeName"
        type="button"
        class="powerbi-analytics-option"
        @click="navigateToShortcut(shortcut.routeName)"
      >
        <div class="powerbi-analytics-card__content">
          <div class="powerbi-analytics-card__heading">
            <div
              class="powerbi-analytics-card__icon"
              :class="`is-${shortcut.variant}`"
              aria-hidden="true"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div class="powerbi-analytics-card__title-group">
              <span class="powerbi-analytics-card__label">
                Analytics
              </span>
              <div class="powerbi-analytics-card__subtitle-group">
                <h2>{{ shortcut.title }}</h2>
              </div>
            </div>
          </div>
          <div class="powerbi-analytics-card__description-group">
            <p>{{ shortcut.description }}</p>
          </div>

          <span
            v-if="shortcuts.length === 1"
            class="powerbi-analytics-card__action"
          >
            {{ $t('open') }}
            <i class="f7-icons" aria-hidden="true">chevron_right</i>
          </span>
        </div>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PowerBiAnalyticsWidget',
  props: {
    shortcuts: {
      type: Array,
      default: () => [],
    },
    hasOnlineSamples: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateToShortcut(routeName) {
      this.$f7router.navigate(
        { name: routeName },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
